<template>
  <div>
    <v-list class="pa-1">
      <v-list-tile avatar>
        <v-list-tile-content>
          <v-list-tile-title class="text-xs-center"
            >Vouchers Empresa</v-list-tile-title
          >
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-list three-line class="pt-0">
      <template v-for="(voucherEmpresa, index) in vouchersEmpresa.results">
        <v-divider v-if="index > 0" :key="voucherEmpresa.id" inset></v-divider>
        <v-menu
          offset-x
          :key="index"
          left
          transition="slide-x-reverse-transition"
        >
          <template v-slot:activator="{ on }">
            <v-list-tile
              class="grey lighten-3"
              :style="{ border: 'solid 2px red' }"
              avatar
              v-on="on"
            >
              <v-list-tile-action>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-icon color="green darken-2">mdi-domain</v-icon>
                    </span>
                  </template>
                  <span>Voucher Empresa </span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content
                style="height: 110px; font-size: 11pt; font-weight: bold"
              >
                <v-list-tile-title>
                  {{ voucherEmpresa.usuario_utilizador ? voucherEmpresa.usuario_utilizador.nome : 'Não informado' }}
                  {{ voucherEmpresa.usuario_utilizador ? voucherEmpresa.usuario_utilizador.sobrenome : 'Não informado' }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  style="width: 95%"
                  class="grey--text text--darken-3 caption font-weight-medium"
                >
                  Valor:
                  {{ (voucherEmpresa.valor_total || voucherEmpresa.valor) | currency({ fractionCount: 2 }) }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title
                  style="width: 95%"
                  class="grey--text text--darken-3 caption font-weight-medium"
                >
                  Data de utilização:
                  {{
                    voucherEmpresa.data_inativado ? voucherEmpresa.data_inativado.split("-").reverse().join("/") : ''
                  }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-layout column align-center justify-center fill-height>
                  <v-tooltip top lazy>
                    <template v-slot:activator="{ on }">
                      <v-flex v-on="on" shrink>
                        <v-layout fill-height align-end>
                          <v-avatar
                            size="45"
                            v-if="voucherEmpresa.usuario_utilizador"
                          >
                            <img
                              v-if="
                                voucherEmpresa.usuario_utilizador
                                  .url_imagem_perfil
                              "
                              :src="
                                voucherEmpresa.usuario_utilizador
                                  .url_imagem_perfil
                              "
                            />
                            <v-icon size="45" v-else>face</v-icon>
                          </v-avatar>
                        </v-layout>
                      </v-flex>
                    </template>
                    <span v-if="voucherEmpresa.usuario_utilizador">
                      {{ voucherEmpresa.usuario_utilizador.nome }}
                    </span>
                  </v-tooltip>
                  <v-flex
                    v-if="voucherEmpresa.usuario_utilizador"
                    class="grey--text text--darken-4 caption font-weight-medium"
                    shrink
                    v-text="voucherEmpresa.usuario_utilizador.nome"
                  ></v-flex>
                  <v-flex
                    v-if="voucherEmpresa.veiculo"
                    class="grey--text text--darken-4 caption font-weight-medium"
                    shrink
                    v-text="voucherEmpresa.veiculo.identificacao"
                  ></v-flex>
                  <v-list-tile-sub-title
                    v-if="voucherEmpresa.veiculo"
                    class="grey--text text--darken-3 caption font-weight-medium"
                  ></v-list-tile-sub-title>
                </v-layout>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-menu>
      </template>
    </v-list>
    <div class="text-xs-center pa-2">
      <v-pagination v-model="paginationCash.page" :length="pagesCash" circle />
    </div>
    <!-- <v-list>
      <template v-if="!voucherEmpresa.abastecido">
        <v-list-tile ripple @click="vincularCupom(voucherEmpresa)">
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center body-2 success--text"
              >CONFIRMAR ABASTECIMENTO</v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile-avatar>
            <v-icon color="success">done_all</v-icon>
          </v-list-tile-avatar>
        </v-list-tile>
      </template>
      <template v-else>
        <v-list-tile ripple @click="editarCupom(voucherEmpresa)">
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center body-2 success--text"
              >RESUBMETER CUPOM FISCAL</v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile-avatar>
            <v-icon color="success">insert_drive_file</v-icon>
          </v-list-tile-avatar>
        </v-list-tile>
        <v-list-tile ripple @click="cancelarAbastecimento(voucherEmpresa)">
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center body-2 error--text"
              >CANCELAR ABASTECIMENTO</v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile-avatar>
            <v-icon color="error">close</v-icon>
          </v-list-tile-avatar>
        </v-list-tile>
      </template>
    </v-list> -->
    <v-dialog
      lazy
      width="500"
      :fullscreen="$vuetify.breakpoint.xs"
      v-model="dialogVincularCupom"
    >
      <vincular-cupom
        @fechar="dialogVincularCupom = false"
        :voucherEmpresa="voucherEmpresa"
      ></vincular-cupom>
    </v-dialog>
    <v-dialog
      lazy
      width="500"
      :fullscreen="$vuetify.breakpoint.xs"
      v-model="dialogEditarCupom"
    >
      <editar-cupom
        @fechar="dialogEditarCupom = false"
        :voucherEmpresa="voucherEmpresa"
      ></editar-cupom>
    </v-dialog>
    <v-dialog lazy width="550" v-model="dialogHistoricoCaixa">
      <historico-caixa :visible="dialogHistoricoCaixa"></historico-caixa>
    </v-dialog>
  </div>
</template>

<script>
import HistoricoCaixa from '@/components/dialogs/DialogHistoricoCaixa'

export default {
  components: { HistoricoCaixa },
  data () {
    return {
      vouchersEmpresa: [],
      paginationCash: {
        rowsPerPage: 5,
        page: 1
      },
      dialogHistoricoCaixa: false,
      dialogVincularCupom: false,
      dialogEditarCupom: false,
      voucherEmpresa: null
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    },
    pagesCash () {
      let count = this.vouchersEmpresa.count
      if (this.paginationCash.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.paginationCash.rowsPerPage)
    }
  },
  methods: {
    carregarVoucherEmpresa () {
      this.$store.dispatch('historicoEmpresa', { 'cnpj': this.frentista.posto.cnpj, 'pagination': this.paginationCash }).then(value => {
        this.vouchersEmpresa = value
      })
    },
    maskedCPF (cpf) {
      let newCpf = `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, 2)}`
      return newCpf
    },
    cancelarAbastecimento (voucherEmpresa) {
      this.$store.dispatch('cancelarAbastecimentoVoucher', voucherEmpresa).then(() => {
        voucherEmpresa.abastecido = false
      })
    },
    editarCupom (voucherEmpresa) {
      this.voucherEmpresa = voucherEmpresa
      this.dialogEditarCupom = true
    },
    vincularCupom (voucherEmpresa) {
      this.voucherEmpresa = voucherEmpresa
      this.dialogVincularCupom = true
    }
  },
  watch: {
    paginationCash: {
      handler (val, oldval) {
        this.$store.dispatch('historicoEmpresa', { 'cnpj': this.frentista.posto.cnpj, 'pagination': this.paginationCash }).then(value => {
          this.vouchersEmpresa = value
        })
      },
      deep: true
    }
  },
  mounted () {
    if (this.frentista) {
      this.carregarVoucherEmpresa()
    }
  }
}
</script>
